import React, { useContext, useState } from "react";

import PropTypes from "prop-types";
import { useHistory, useLocation } from "react-router-dom";

import Tab from "@mui/material/Tab";
import Grid from "@mui/material/Grid";
import Tabs from "@mui/material/Tabs";
import { Box } from "@material-ui/core";

import Profile from "./Profile/profile"
import Honeypot from "./Honeypot"
import CreditCards from './CreditCards';
import BuyingEmailsHome from './BuyingEmails';

import AppContext from '../../context/AppProvider';
import InformationMessage from '../../components/modals/InformationMessage';
import { UserType } from "../../constants/enums";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "../../features/auth/authSlice";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{ width: "100%" }}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function Home() {
  const { message } = useContext(AppContext);
  const user= useSelector(selectCurrentUser);

  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const history = useHistory();

  let tabIndexFromQuery = Number(query.get("tab_index")) || 0;

  const [tabIndex, setTabIndex] = React.useState(tabIndexFromQuery);

  const userDistribution = user?.userDistribution;

  const handleChange = (event, newValue) => {
    setTabIndex(newValue);
    query.set("tab_index", newValue);
    history.push({ search: query.toString() });
  };

  const [tabs] = useState([
    { index: 0, label: "Profile", component: <Profile />, hideUserTypes: [], id: "MyHive-Profile-Tab" },
    { index: 1, label: "Buying Emails", component: <BuyingEmailsHome />, hideUserTypes: [UserType.HiveAdmin], id: "MyHive-BuyingEmail-Tab" },
    { index: 2, label: "Credit Cards", component: <CreditCards />, hideUserTypes: [], id: "MyHive-CreditCards-Tab" },
    { index: 3, label: "Honeypot", component: <Honeypot />, hideUserTypes: [UserType.HiveAdmin], id: "MyHive-Honeypot-Tab" }
  ]);
    
  return (
    <Box sx={{ width: "100%", display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center", padding: "0 1em", marginTop: "8em" }}>
      <Box sx={{ width: { xs: "100%", sm: "90%", md: "80%", lg: "80%", xl: "80%" } }} >
        {
          (message?.title !== "" && message?.message !== "" && message?.enabled && message?.showOnAllPages)
          &&
          <InformationMessage
            title={message?.title}
            message={message?.message}
          />
        }
      </Box>
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
        style={{ width: "90%" }}
      >
        <Box style={{borderBottomWidth: 1, borderBottomStyle: "solid", borderColor: "var(--light-yellow)", width: "100%"}}>
          <Tabs
            value={tabIndex}
            onChange={handleChange}
            aria-label="basic tabs example"
            textColor="inherit"
            indicatorColor="primary"
          >

            {
              tabs.filter(tab => !tab.hideUserTypes.some(type => type === user.userTypeId))
                .map(tab => (
                  <Tab key={tab.index} value={tab.index} label={tab.label} {...a11yProps(tab.index)} id={tab.id} disabled={(userDistribution === undefined || userDistribution === false) && tab.label === "Credit Cards"} 
                  />
                ))
            }

            <span style={{ width: "100%" }} />
          </Tabs>
        </Box>

        {
          tabs.filter(tab => !tab.hideUserTypes.some(type => type === user.userTypeId))
            .map(tab => (
              <TabPanel key={tab.label} value={tabIndex} index={tab.index}>
                {tab.component}
              </TabPanel>
            ))
        }

      </Grid>
    </Box>
  );
}
